<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar"/>
      <div id="select-tax-page" class="qi-content">
        <header>
          <h1>Seleção da Taxa do Curso</h1>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <vs-row vs-justify="left">
          <SelectedCourseBox></SelectedCourseBox>
          <SelectedOfferBox></SelectedOfferBox>
        </vs-row>

        <div class="saldo-container">
          <h3 class="saldo-title">
            Aproveitamento de Taxa
          </h3>
          <p class="saldo-description">
            Carregar saldo disponível de pré-matrículas anteriores.
          </p>

          <div class="saldo-form-row">
            <div class="saldo-input-wrapper">
              <vs-input
                placeholder="Digite o CPF do responsável"
                v-model="findedCpf"
                class="saldo-input"
              />
            </div>
            
            <vs-button
              class="saldo-button"
              icon="search"
              type="filled"
              color="danger"
              @click="searchBalance()"
            >
              Buscar Saldo
            </vs-button>
          </div>
        </div>

        <h3>
          Taxas Disponíveis
          <span v-if="level === 'S'">- Supervisão</span>
          <span v-if="level === 'C'">- Coordenação</span>
        </h3>
        <vs-row>
          <vs-col v-for="(tax, i) in taxOptions" :key="tax.IDTAXA" vs-w="4" vs-xs="12">
            <div @click="selectTax(tax)">
              <vs-card
                class="choosable-card"
                :class="{
                  selected: tax.IDTAXA === taxSelected.IDTAXA,
                  disabled: !tax.dueDateOptions.length,
                }"
              >
                <div class="no-flex" slot="header">
                  <h4 class="text-center">Opção {{ i + 1 }}</h4>
                  <vs-row style="margin-top: 20px;">
                    <div v-if="taxEdit">
                      <vs-input
                        label-placeholder="Valor Total"
                        type="number"
                        v-model="tax.VALORTAXA"
                        @input="recalcularValores(tax)" 
                      />
                    </div>
                    <h3 v-else>Total: R${{ tax.VALORTAXA }}</h3>
                  </vs-row>
                </div>
                <div class="spacing-children">
                  <p v-if="tax.QTDDISPONIVEL != '9999'">
                    Quantidade disponível para uso: {{ tax.QTDDISPONIVEL }}
                  </p>
                  <p>Valor Bruto: R${{ tax.VALORBRUTO }}</p>
                  <p>Desconto Aplicado: {{ tax.DESCONTO }}%</p>
                  <p>Pagamento até {{ tax.ULTIMOVENCVALIDO }}</p>
                  <vs-divider/>
                  <div>
                    <label :for="'select-' + tax.IDTAXA">
                      Data de Vencimento:
                    </label>
                    <vs-select
                      :id="'select-' + tax.IDTAXA"
                      v-model="tax.dueDate"
                      v-if="tax.dueDateOptions.length"
                      v-on:change="selectTax(tax)"
                      :disabled="!!reusableTax"
                    >
                      <vs-select-item
                        v-for="(date, index) in tax.dueDateOptions"
                        :key="index"
                        :value="date"
                        :text="date"
                      />
                    </vs-select>

                    <small 
                      v-if="isCriticalClass" 
                      style="color: red; display: block; margin-top: 10px;"
                    >
                      * Para turmas críticas, o pagamento deve ser realizado no mesmo dia.
                    </small>

                    <p v-else>Taxa Indisponível</p>
                  </div>
                </div>
              </vs-card>
            </div>
          </vs-col>
        </vs-row>
        <vs-alert
          title="Erro ao buscar as taxas do curso"
          class="margin"
          color="danger"
          v-if="error"
        >
          {{ error }}
        </vs-alert>
        <h3>Formas de Pagamento Disponíveis</h3>
        <vs-row vs-justify="left">
          <vs-col
            vs-w="4"
            v-for="(payment, index) in paymentOptions"
            v-bind:key="index"
            :value="payment.IDFORMAPGTO"
          >
            <div @click="selectPayment(payment)">
              <vs-card
                class="choosable-card"
                :class="{
                  selected: payment === paymentSelected,
                }"
              >
                <div slot="header">
                  <h3 class="text-center">{{ payment.DESCRICAO.toUpperCase() }}</h3>
                </div>
                <!--<div class="spacing-children">
                  <p>Desconto: {{ payment.PERCDESC }}%</p>
                  <p>Valor final: R${{ getTaxWithDiscount(payment.PERCDESC) }}</p>
                </div>-->
              </vs-card>
            </div>
          </vs-col>
        </vs-row>
        <vs-alert
          title="Formas de Pagamento da Taxa"
          class="margin"
          color="danger"
          v-if="error2"
        >
          {{ error2 }}
        </vs-alert>

        <vs-row>
          <vs-col vs-w="4" vs-xs="12" v-if="!edit && level != 'S'">
            <vs-button
              icon="refresh"
              style="width: 100%;"
              @click="updateTaxes('S')"
              type="filled"
              color="danger"
            >
              Carregar Opções Supervisor
            </vs-button>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12" v-if="!edit && level == 'S'">
            <vs-button
              icon="highlight_off"
              style="width: 100%;"
              @click="updateTaxes('V')"
              type="filled"
            >
              Remover Opções Supervisor
            </vs-button>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12" v-if="level != 'C'">
            <vs-button
              icon="refresh"
              style="width: 100%;"
              @click="updateTaxes('C')"
              type="filled"
              color="danger"
              :disabled="!edit && !scholarshipCoordinator"
            >
              Carregar Opções Coordenador
            </vs-button>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12" v-if="level == 'C'">
            <vs-button
              icon="highlight_off"
              style="width: 100%;"
              @click="updateTaxes('V')"
              type="filled"
            >
              Remover Opções Coordenador
            </vs-button>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12">
            <vs-button
              icon="check_circle"
              style="width: 100%;"
              :disabled="!taxSelected.IDTAXA || !paymentSelected.IDFORMAPGTO || !taxSelected.dueDate"
              @click="goFoward()"
              type="filled"
              color="#139B0E"
            >
              Confirmar e Avançar
            </vs-button>
          </vs-col>
          <vs-col vs-w="12" vs-xs="12">
            <vs-button
              icon="check_circle"
              style="width: 100%;"
              v-if="edit"
              @click="scapeTax()"
              type="filled"
              color="#139B0E"
            >
              Continuar sem Alterar
            </vs-button>
          </vs-col>
        </vs-row>
      </div>
    </div>
    <ConsultValidationMat />
  </div>
</template>
<script>
import SelectedCourseBox from "../components/SelectedCourseBox.vue";
import SelectedOfferBox from "../components/SelectedOfferBox.vue";
import ConsultValidationMat from "../components/ConsultValidationMat.vue"
import {
  getStepsInformation,
  getLoginDataFromStorage,
  updateStepsInformation,
} from "../helpers/storage";
import FinancialService from "../services/financial";
import { formatDateToUSA, updateDiscussion, getDateOptions } from "../helpers";
import moment from "moment";

export default {
  name: "Tax",
  components: {
    SelectedCourseBox,
    SelectedOfferBox,
    ConsultValidationMat
  },
  data: () => ({
    taxOptions: [],
    paymentOptions: [],
    profiles: [],
    scholarshipCoordinator: false,
    error: null,
    error2: null,
    paymentSelected: {},
    taxSelected: {},
    dueDate: "",
    level: "V",
    edit: false,
    taxEdit: false,
    isCriticalClass: false,
    findedCpf: "",
    reusedTax: null,
  }),
  mounted() {
    const { ...user } = getLoginDataFromStorage();
    this.profiles = user.profiles;

    if (this.profiles && this.profiles.includes("EditaTaxa")) {
      this.taxEdit = true;
    }

    const profileCoordinator = this.profiles.find(element => element == "SupervisorVenda");

    if(profileCoordinator) {
      this.scholarshipCoordinator = true;
    } else {
      this.scholarshipCoordinator = false;
    }

    this.$vs.loading({
      color: "danger",
    });
    const { offer, course, edit, preRegistration } = getStepsInformation();

    this.edit = edit;
    let classificationId, qualificationId;
    edit
      ? (classificationId = preRegistration.IDCLASSIFICACAO)
      : (classificationId = course.IDCLASSIFICACAO);
    edit
      ? (qualificationId = preRegistration.IDHABILITACAOFILIAL)
      : (qualificationId = offer.IDHABILITACAOFILIAL);

    this.updateTaxes("V");
    new FinancialService()
      .getPaymentOptions(classificationId, qualificationId, "T")
      .then(({ data }) => {
        this.paymentOptions = Array.isArray(data) ? data : [data];
        this.$vs.loading.close();
      })
      .catch(({ response }) => {
        if (response && response.data) {
          this.error2 = response.data.error + '. Entre em contato com o Financeiro';
        }
        this.$vs.loading.close();
      });
  },
  methods: {
    updateTaxes(level) {
      this.taxOptions = [];
      this.level = level;
      this.$vs.loading({
        color: "danger",
      });
      const {
        offer,
        classData,
        course,
        preRegistration,
        edit,
        preRegistrationSubjects,
      } = getStepsInformation();
      this.isCriticalClass = classData && classData.PERCTURMACRITICA && classData.PERCTURMACRITICA !== '0.00';
      let classificationId, qualificationId, subjectId;
      edit
        ? (classificationId = preRegistration.IDCLASSIFICACAO)
        : (classificationId = course.IDCLASSIFICACAO);
      edit
        ? (qualificationId = preRegistration.IDHABILITACAOFILIAL)
        : (qualificationId = offer.IDHABILITACAOFILIAL);
      edit
        ? (subjectId = this.getFirstSubjectId(preRegistrationSubjects))
        : (subjectId = classData.IDTURMADISC);

      new FinancialService()
        .getTaxes(
          classificationId,
          qualificationId,
          this.level,
          formatDateToUSA(new Date()),
          subjectId
        )
        .then(({ data }) => {
          const taxOptions = Array.isArray(data) ? data : [data];
          this.taxOptions = taxOptions.map((tax) => {
            const originalDates = classData && classData.PERCTURMACRITICA && classData.PERCTURMACRITICA !== '0.00'
              ? [moment().format("DD/MM/YYYY")]
              : getDateOptions(
                  moment().startOf("day"),
                  moment(tax.ULTIMOVENCVALIDO, "DD/MM/YYYY")
                );
            
            return {
              ...tax,
              originalValue: tax.VALORTAXA,
              originalDueDateOptions: [...originalDates],
              dueDateOptions: [...originalDates],
              dueDate: "",
            };
          });
          this.taxSelected = this.taxOptions[0];

          if (this.reusableTax) {
            this.applyTaxReuse();
          }
          this.$vs.loading.close();
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
          this.$vs.loading.close();
        });
      this.taxSelected = {};
    },

    searchBalance() {
      const cleanCpf = this.findedCpf.replace(/\D/g, "");
      console.log(cleanCpf)

      if (!cleanCpf || cleanCpf.length < 11) {
        this.$vs.notify({ 
          title: 'Atenção!', 
          text: 'Por favor, informe um CPF válido.', 
          color: 'warning' 
        });
        return;
      }

      this.$vs.loading({ color: "danger" });

      new FinancialService()
        .getReusableTax(cleanCpf)
        .then(({ data }) => {
          this.$vs.loading.close();

          if (data && data.length > 0) {
            this.reusableTax = data[0]; 
            
            this.$vs.notify({
              title: 'Balance Found!',
              text: `Um crédito de R$ ${this.reusableTax.VALORBAIXADO} foi encontrado nesse CPF.`,
              color: 'success'
            });

            this.applyTaxReuse();
          } else {
            this.reusableTax = null;
            this.applyTaxReuse();
            this.$vs.notify({
              title: 'Sem saldo!',
              text: 'Não foi encontrado saldo de outras matrículas neste CPF.',
              color: 'warning'
            });
          }
        })
        .catch((error) => {
          console.error("ERRO:", error.response ? error.response.data : error);
          this.$vs.loading.close();
          this.$vs.notify({ 
            title: 'Error', 
            text: 'Falha ao buscar saldo.', 
            color: 'danger' 
          });
        });
    },

    applyTaxReuse() {
      if (!this.reusableTax) {
        this.resetTaxOptions();
        return;
      }
      const creditValue = this.reusableTax ? parseFloat(this.reusableTax.VALORBAIXADO) : 0;      
      let reuseDate = null;
      if (this.reusableTax.DATABAIXA) {
        reuseDate = moment(this.reusableTax.DATABAIXA).format("DD/MM/YYYY");
        if (reuseDate === "Invalid date") reuseDate = moment().format("DD/MM/YYYY");
      } else {
        reuseDate = moment().format("DD/MM/YYYY");
      }

      if (creditValue <= 0) {
        this.$vs.notify({
          title: 'Atenção com o Saldo',
          text: 'O CPF possui um registro de taxa, mas o valor disponível é R$ 0,00.',
          color: 'warning',
          time: 6000
        });
        this.resetTaxOptions();
        return;
      }

      this.taxOptions.forEach(tax => {
        tax.VALORTAXA = "0.00";
        tax.DESCONTO = "100.00";
        tax.dueDate = reuseDate;
        tax.dueDateOptions = [reuseDate];
      });
      if (this.taxOptions.length > 0) {
        this.selectTax(this.taxOptions[0]);
      }
    },
    resetTaxOptions() {
      this.taxOptions.forEach(tax => {
        const originalValue = parseFloat(tax.originalValue) || 0;
        tax.VALORTAXA = originalValue.toFixed(2);
        this.recalcularValores(tax);
        
        if (tax.originalDueDateOptions) {
          tax.dueDateOptions = [...tax.originalDueDateOptions];
        }
        tax.dueDate = "";
      });
    },
    recalcularValores(tax) {
      const valorFinal = parseFloat(tax.VALORTAXA) || 0;
      const valorBruto = parseFloat(tax.VALORBRUTO);

      if (!valorBruto || valorBruto <= 0) {
        tax.DESCONTO = 0;
        return;
      }
      const novoDesconto = 100 - (valorFinal / valorBruto) * 100;
      tax.DESCONTO = Math.max(0, novoDesconto).toFixed(2);
    },

    getFirstSubjectId(subjects) {
      let find = false;
      let cont = 0;
      while (!find && cont < subjects.length) {
        if (subjects[cont].TIPO == "N" || subjects[cont].TIPO == "E")
          find = true;
        cont++;
      }
      return subjects[cont - 1].IDTURMADISC;
    },

    selectPayment(paymentMethod) {
      this.paymentSelected = paymentMethod;
    },
    selectTax(tax) {
      if (tax.dueDate) {
        this.taxSelected = tax;
      }
    },
    getTaxWithDiscount(discount) {
      if (!this.taxSelected.VALORTAXA) {
        return "0.00";
      }
      const discountNumber = Number(discount) / 100;
      const total = Number(this.taxSelected.VALORTAXA) * (1 - discountNumber);
      return total.toFixed(2);
    },
    scapeTax() {
      this.$router.push("/payment");
    },
    goFoward() {

      if (this.reusableTax) {
        this.taxSelected.idLanReaTx = this.reusableTax.IDLAN; 
      } else {
        this.taxSelected.idLanReaTx = "-1";
      }

      updateDiscussion("Selecionou Taxa de Matrícula: R$" + this.taxSelected.VALORTAXA + ' com vencimento em ' + this.taxSelected.dueDate + ' no ' + this.paymentSelected.DESCRICAO, {
        tax: this.taxSelected.IDTAXA,
      }).finally(() => {
        updateStepsInformation({
          tax: this.taxSelected,
          taxPayment: this.paymentSelected,
          reusedCpf: this.reusableTax ? this.findedCpf.replace(/\D/g, "") : null
        });
        this.$router.push("/payment");
      });
    },
  },
};
</script>

<style>
#select-tax-page .no-flex div.vs-col {
  flex: 0 !important;
}
#select-tax-page .text-center {
  text-align: center;
}
#select-tax-page .choosable-card {
  cursor: pointer;
}
.saldo-container {
  margin: 30px 0;
  padding: 25px;
  background-color: #f9f9f9;
  border-radius: 8px;
  border: 1px solid #eaeaea;
}

.saldo-title {
  margin-top: 0;
  color: #333;
  margin-bottom: 5px;
}

.saldo-description {
  color: #666;
  font-size: 0.95rem;
  margin-bottom: 20px;
}

.saldo-form-row {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.saldo-input-wrapper {
  flex: 1;
  max-width: 350px;
}

.saldo-input-wrapper .vs-con-input {
  width: 100%;
}

.saldo-button {
  margin: 0 !important; 
}

#select-tax-page .choosable-card:hover {
  cursor: pointer;
  box-shadow: 0 0 5px 3px rgba(var(--vs-primary), 0.7);
}

#select-tax-page .choosable-card.selected {
  box-shadow: 0 0 0 2.75px rgb(var(--vs-primary)) !important;
  cursor: default;
}

#select-tax-page .choosable-card.disabled,
#select-tax-page .choosable-card.disabled:hover {
  cursor: default;
  color: #888;
  box-shadow: none;
}

#select-tax-page .spacing-children > p,
#select-tax-page .spacing-children > div {
  margin: 12px 0;
}
</style>
